'use strict';

module.exports = function reference (typeOrRequest, ...idOrRequestArgs) {
  let referenceType = typeOrRequest.getReferenceType();
  return new referenceType(typeOrRequest, idOrRequestArgs);
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/reference.js